import RecordManager from "@/components/RecordManager";
import { subjectsForTrack } from "@/lib/constants";
import { Progress } from "@/components/ui/progress";

export default function UnitCompletion({ studentId, readOnly, track }) {
  const subjects = subjectsForTrack(track);
  return (
    <RecordManager
      studentId={studentId}
      readOnly={readOnly}
      kind="unit-progress"
      title="Ünite / Konu Bitme Takibi"
      description="Derslerin ünitelerine göre konu tamamlanma oranları."
      fields={[
        { name: "exam", label: "Sınav", type: "select", options: ["TYT", "AYT"], required: true },
        { name: "subject", label: "Ders", type: "select", options: subjects, required: true },
        { name: "unit_no", label: "Ünite No", type: "text" },
        { name: "unit_name", label: "Ünite/Konu", type: "text", wide: true, required: true },
        { name: "completion", label: "Tamamlanma %", type: "number", default: 0, required: true },
      ]}
      columns={[
        { name: "exam", label: "Sınav" },
        { name: "subject", label: "Ders" },
        { name: "unit_no", label: "No" },
        { name: "unit_name", label: "Ünite/Konu" },
        {
          name: "completion",
          label: "Tamamlanma",
          render: (r) => {
            const v = Math.min(100, Number(r.completion || 0));
            return (
              <div className="flex items-center gap-2 min-w-[160px]">
                <Progress value={v} className="h-2 w-28" />
                <span className="font-mono text-xs text-slate-600">%{v}</span>
              </div>
            );
          },
        },
      ]}
    />
  );
}
